import { Component, OnInit, ViewChild, Input, OnDestroy, Pipe, PipeTransform, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { DragulaService } from 'ng2-dragula';
import { formatDate } from '@angular/common';

import { Subscription } from 'rxjs';

//import constants
import { AppSettings } from '../../../constants/app-settings';
import { AppFrontRoutes } from '../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../services/servicing.service';
import { MeasurementService } from '../../../services/measurement.service';
import { ConfirmationDialogService } from '../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../services/general.service';

//import { ServicingCalendarComponent } from '../servicing-calendar/servicing-calendar.component';
import { MeasurementMaintenance } from '../measurement/calibration_planning/calibration_planning.component';

import { CommonUtility } from "../../../utility/commonUtility"
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'measurement',
  templateUrl: './measurement.component.html',
  styleUrls: ['./measurement.component.css'],
  encapsulation: ViewEncapsulation.None
})

@Pipe({
  name: 'multiSpace'
})



export class MeasurementComponent implements OnDestroy, OnInit, AfterViewInit {
  @ViewChild('measureSearch') measureSearch;
  @ViewChild('calibrationSearch') calibrationSearch;
  getPhotoBase64;
  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;

  //common data
  data: any;


  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  addMaintenanceModel: BsModalRef;
  skillsAnalysisModel: BsModalRef;
  addMeasurementModel: BsModalRef;

  deleteOption: any;
  measureTemp: any;
  lang: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  record: any;
  config_employees: any;
  rolepermission: any;
  result: any;
  temp: any;
  subs = new Subscription();

  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');

  constructor(
    private servicingService: ServicingService,
    private measurementService: MeasurementService,
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,
    private dragulaService: DragulaService,
    private utility: CommonUtility
  ) { }


  ngOnInit() {
    //fetch data
    this.data = this.route.snapshot.data['sdata'];
    var role = this.ngxRolesService.getRole('servicing');
    
    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }


    this.getData();
    //tab2 actions
    this.tab2Actions();

    this.subs.add(this.dragulaService.dropModel("records")
    .subscribe(({ sourceModel, targetModel, item }) => {
      let arr = []; let table = [];
      // console.log(sourceModel);
      for (let employee of sourceModel) {
        arr.push(employee.measurementId)
      }
      this.updsorting(arr, table);
    })
  );

    
  this.subs.add(this.dragulaService.dropModel("result")
  .subscribe(({ sourceModel, targetModel, item }) => {
    let arr = []; let table = [];
    // console.log(sourceModel);
    for (let employee of sourceModel) {
      arr.push(employee.ordinaryId)
    }
    this.updsorting1(arr, table);
  })
);



  }

  ngAfterViewInit(): void {
    const that = this
    setTimeout(function(){

      console.log(this.measureSearch)
      fromEvent(this.measureSearch, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        // this.updateFilter(value);
        console.log(that.utility)
        console.log(that.datatableCols1)        
        that.records = that.utility.updateFilter(value,that.datatableCols1,that.records,that.measureTemp)
        console.log(that.records)
      });   

      fromEvent(this.calibrationSearch, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        // this.updateFilter(value);
        console.log(that.utility)
        console.log(that.datatableCols1)        
        that.result = that.utility.updateFilter(value,that.datatableCols2,that.result,that.temp)
        console.log(that.records)
      });         

    },3000)    
  }


  onItemSelect(item: any) {
    console.log(item.item_id);
  }
  onSelectAll(items: any) {
    console.log(items);
  }


  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  datatableConfig(): void {

    this.datatableColumns1();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs1,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.lang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "Kaizen Cloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.lang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCluod DEMO Measurement "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
            },
            {
              extend: 'excel',
              text: this.lang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Measurement "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
            },
            {
              extend: 'print',
              text: this.lang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Measurement "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn1'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableColumns1(): void {

    this.datatableColsDefs1 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols1 = [
      { id: 2, value: this.lang.no, isSelected: false },
      { id: 3, value: this.lang.description, isSelected: false },
      { id: 4, value: this.lang.brand, isSelected: false },
      { id: 5, value: this.lang.model, isSelected: false },
      { id: 6, value: this.lang.dateofpurchase, isSelected: false },
      { id: 7, value: this.lang.internalCode, isSelected: false },
      { id: 8, value: this.lang.serialNumber, isSelected: false },
      { id: 9, value: this.lang.location, isSelected: false },
      { id: 10, value: this.lang.documentAttachment, isSelected: false },
      { id: 11, value: this.lang.measuringRange, isSelected: false },
      { id: 12, value: this.lang.resolution, isSelected: false },
      { id: 13, value: this.lang.maxallowedError, isSelected: false },
      { id: 17, value: this.lang.instrumentStatus, isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }


  datatableConfig2(): void {

    this.datatableColumns2();

    this.datatableOptions2 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs2,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table2 = new $.fn.dataTable.Api('#table2');

          var count = table2.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table2.rows().deselect();
            selected = false;
          }
          else
          table2.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table2 = new $.fn.dataTable.Api('#table2');

        table2
          .on('select deselect', function (e, dt, type, indexes) {

            var table2 = new $.fn.dataTable.Api('#table2');
            var selected = table2.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table2, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: 'Export Csv',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "Kaizen Cloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export Pdf',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCluod DEMO Measurement "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Measurement "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'print',
              text: 'Export Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Measurement "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn2'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableColumns2(): void {

    this.datatableColsDefs2 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];
    this.datatableCols2 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 3, value: 'Instrument Description', isSelected: false },
      { id: 4, value: 'Internal Code', isSelected: false },
      { id: 5, value: 'Serial Number', isSelected: false },
      { id: 6, value: 'Brand', isSelected: false },
      { id: 7, value: 'Model', isSelected: false },
      { id: 8, value: 'Plan Code', isSelected: false },
      { id: 9, value: 'Plan Description', isSelected: false },
      { id: 10, value: 'Execution Date', isSelected: false },
      { id: 11, value: 'Days Left', isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }


  datatableFilter(): void {

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = data[16] || '';
      const filt2 = data[18] || '';
      const filt3 = data[17] || '';
      // const filt4 = data[14] || '';

      let a = this.filter1;
      let aa = this.filter2;
      let aaa = this.filter3;
      // let aaaa = this.filter4;

      var status1 = false;
      var status2 = false;
      var status3 = false;
      // var status4 = false;

      if (Object.keys(a).length == 0)
        status1 = true;
      else {
        Object.keys(a).forEach(function (key) {

          // console.log(a[key].item_id);
          // console.log(filt1);

          if (a[key].item_id && filt1 == a[key].item_id)
            status1 = true;
        });
      }

      if (Object.keys(aa).length == 0)
        status2 = true;
      else {
        Object.keys(aa).forEach(function (key) {
          if (aa[key].item_id && filt2 == aa[key].item_id)
            status2 = true;
        });
      }

      if (Object.keys(aaa).length == 0)
        status3 = true;
      else {
        Object.keys(aaa).forEach(function (key) {
          if (aaa[key].item_id && filt3 == aaa[key].item_id)
            status3 = true;
        });
      }

      // if (Object.keys(aaaa).length == 0)
      //   status4 = true;
      // else {
      //   Object.keys(aaaa).forEach(function (key) {
      //     if (aaaa[key].item_id && filt4 == aaaa[key].item_id)
      //       status4 = true;
      //   });
      // }

      if (status1 && status2 && status3)
        return true;
      else
        return false;


    });

  }

  datatableFilterAction(): void {
    // console.log(DataTables.Api);
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.draw();

      // dtInstance.columns().every(function () {});


    });
  }

  getData() {

    this.measurementService.getList()
      .subscribe(
        (res) => {
          this.lang = this.measurementService.listLang(res);
          this.records = this.measureTemp = res.data.get_record;
          this.record = res;
          // console.log(this.record.data.config_employees);
          
          this.mulitSelect();

          //load datatable
          this.datatableConfig();
          this.datatableFilter();

        }
      );

  }


  tab2Actions(): void {

    this.measurementService.getCalibrationList()
    .subscribe(
      (res) => {
        this.lang = this.measurementService.listLang(res);
        this.result = this.temp = res.data.result;
        // console.log(res);
        // this.mulitSelect();

        //load datatable
        this.datatableConfig2();
        this.datatableFilter();

      }
    );
  }


  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.MEASUREMENT]);
      });
  }

  success(msg: any) {

    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    this.redirect();
  }


  mulitSelect() {
    this.dropdownList = [
      { item_id: this.lang.internal, item_text: this.lang.internal },
      { item_id: this.lang.external, item_text: this.lang.external },
    ];


    let that = this;

    let loca1 = this.record.data.config_employees;
    Object.keys(loca1).forEach(function (key) {
      that.dropdownList1.push({ item_id: 'test', item_text: 'test1' },)
    });

    this.dropdownList2 = [
      { item_id: this.lang.active, item_text: this.lang.active },
      { item_id: this.lang.decommissioned, item_text: this.lang.decommissioned },
    ];

    this.dropdownList3 = [
      { item_id: this.lang.active, item_text: this.lang.active },
      { item_id: this.lang.decommissioned, item_text: this.lang.decommissioned },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false
    };

    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };
  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

  }



  export2_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      this.datatableCols2[i].isSelected = selected;
    }
    this.datatable_export2_choose_column();

  }

  export2_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].id == id)
        this.datatableCols2[i].isSelected = selected;
    }

    this.datatable_export2_choose_column();

  }

  datatable_export2_choose_column(): void {

    var table1_name = '#table2';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].isSelected)
        table1.column(parseInt(this.datatableCols2[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols2[i].id)).deselect();
    }

  }



  delete(ID) {

    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.measurementService.delete(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.measurementService.multiDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }

  cmultiDelete() {

    var table2 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table2.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.measurementService.cmultiDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }



  multiDelete1() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.multiDelete1(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }

  multiDuplicate() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    console.log(selectedRows);

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to duplicate the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.measurementService.multiDuplicate(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });

  }



  duplicate(ID) {

    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure you duplicate this line?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.measurementService.duplicate(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });


  }




  onPhotoPickerChange(ev) {
    let file = ev.target.files[0];
    file = ev.target.files[0];

    // console.log(file.name);
    let file_name = file.name;
    if (!(/\.(csv)$/i).test(file_name)) {
      alert('Please upload valid excel file_name .csv only.');
      $('#file').val('');
    }
    else {
      let fs = new FileReader();
      fs.onload = (res: any) => {
        this.getPhotoBase64 = res.target.result;
        $('#profile_input').val('');
      };
      fs.readAsDataURL(file);
    }
  }

  onclick() {
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    if (profileImage != undefined && $('#file').val() != '') {
      this.measurementService.updateProfile(profileImage)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#datatableExport2").modal("hide");

            }
            else {
              this.error(res.msg);
              $("#datatableExport2").modal("hide");

            }
          });
    }
  }

  // chkEmpty(value: String): String {
  //   return value.replace(' ', '&nbsp;');
  //   }


  addMeasurement(OID, SID, SPID) {
    this.addMeasurementModel = this.modalService.show(MeasurementMaintenance, { class: 'modal-lgs', initialState: { 'ID': OID, 'SID': SID, 'PID': SPID, 'action': 'modify', 'langs': this.lang } });
  }


  updsorting(data: any, table: any) {
    this.measurementService.sorting(data, table)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);

          }
          else {
            this.error(res.msg);

          }
        });
  }

  updsorting1(data: any, table: any) {
    this.measurementService.sorting1(data, table)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);

          }
          else {
            this.error(res.msg);

          }
        });
  }


}
